<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'New business' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'New business' | transloco }}</h2>
      </div>
    </header>

    <form [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="bb-card bb-p-20">
        <div class="bb-form-grid">

          @if(submitted && (data.invalid || !selectedUsers.length)) {
            <div class="bb-form-alert bb-field-full" role="alert">
              {{ 'Review the business data before saving' | transloco }}

              @if(getMissingRequiredCount() > 0) {
                <span>
                  ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
                </span>
              }
            </div>
          }

          <!-- Name -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="name"
              placeholder="{{ 'NameAr' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('name')?.touched && data.get('name')?.invalid,
                'is-valid': data.get('name')?.touched && data.get('name')?.valid
              }"
            />

            @if(shouldShowError('name')) {
              <div class="bb-field-error">{{ getErrorMessage('name', ('NameAr' | transloco)) }}</div>
            }
          </div>

          <!-- English Name -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="name_en"
              placeholder="{{ 'Name' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('name_en')?.touched && data.get('name_en')?.invalid,
                'is-valid': data.get('name_en')?.touched && data.get('name_en')?.valid
              }"
            />

            @if(shouldShowError('name_en')) {
              <div class="bb-field-error">{{ getErrorMessage('name_en', ('Name' | transloco)) }}</div>
            }
          </div>

          <!-- Phone -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="phonenumber"
              placeholder="{{ 'phone' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('phonenumber')?.touched && data.get('phonenumber')?.invalid,
                'is-valid': data.get('phonenumber')?.touched && data.get('phonenumber')?.valid
              }"
            />

            @if(shouldShowError('phonenumber')) {
              <div class="bb-field-error">{{ getErrorMessage('phonenumber', ('phone' | transloco)) }}</div>
            }
          </div>

          <!-- Another Phone -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="another_phonenumber"
              placeholder="{{ 'Another Phone Number' | transloco }}"
            />
          </div>

          <!-- Website -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="website_link"
              placeholder="{{ 'website_link' | transloco }}"
            />
          </div>

          <!-- Facebook -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="facebook_link"
              placeholder="{{ 'facebook' | transloco }}"
            />
          </div>

          <!-- Instagram -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="instagram_link"
              placeholder="{{ 'instagram' | transloco }}"
            />
          </div>

          <!-- TikTok -->
          <div class="bb-field">
            <input
              class="bb-input"
              type="text"
              formControlName="tiktok_link"
              placeholder="{{ 'tiktok' | transloco }}"
            />
          </div>

          <!-- Location -->
          <div class="bb-field bb-field-full">
            <input
              class="bb-input"
              type="text"
              formControlName="location"
              placeholder="{{ 'business location' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('location')?.touched && data.get('location')?.invalid,
                'is-valid': data.get('location')?.touched && data.get('location')?.valid
              }"
            />
          </div>

          <!-- Select Users -->
          <div class="bb-field bb-field-full">
            <label class="bb-label">
              {{ 'select user' | transloco }}
            </label>

            <mat-form-field appearance="outline" class="bb-chip-mat-field">
        <mat-select
  multiple
  panelClass="bb-user-select-panel"
  (selectionChange)="onProductSelected($event)"
  [formControl]="providers"
>

                <mat-select-trigger>
                  <div class="bb-shift-selected-users">
                    <span class="bb-shift-user-chip" *ngFor="let id of providers.value">
                      {{ getUserName(id) }}
                    </span>
                  </div>
                </mat-select-trigger>

                <div class="user-search-option">
                  <div class="user-search-box" (click)="$event.stopPropagation()">
                    <input
                      class="user-search-input"
                      type="text"
                      [value]="userSearchValue"
                      [placeholder]="'Search by user name' | transloco"
                      (input)="onUserSearchChange($event)"
                      (keydown)="$event.stopPropagation()"
                    />

                    @if(userSearchValue) {
                      <button class="user-search-clear" type="button" (click)="clearUserSearch($event)">
                        X
                      </button>
                    }
                  </div>
                </div>

                @for (user of filteredProviders; track user) {
                  <mat-option [value]="user.id">
                    <div class="user-option">
                      <div class="user-info">
                        <span class="name">
                          {{ getUserOptionLabel(user) }}
                        </span>

                        <span class="username" *ngIf="getUserMeta(user)">
                          {{ getUserMeta(user) }}
                        </span>
                      </div>
                    </div>
                  </mat-option>
                }

                @if(filteredProviders.length === 0) {
                  <mat-option disabled>
                    {{ 'No users found' | transloco }}
                  </mat-option>
                }

              </mat-select>
            </mat-form-field>

            @if(shouldShowUsersError()) {
              <div class="bb-field-error">{{ 'Select at least one user' | transloco }}</div>
            }
          </div>

          <!-- Image Upload -->
          <div class="bb-field bb-field-full">
            <label class="bb-label">
              {{ "image" | transloco }}
            </label>

            <div class="bb-upload-card">
              <input type="file" accept="image/*" (change)="onFileSelected($event)" #fileInput hidden />

              <div class="bb-upload-area" (click)="fileInput.click()">
                <div *ngIf="!imagePreview" class="bb-upload-placeholder">
                  <span class="bb-upload-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect x="3" y="7" width="18" height="14" rx="3" stroke="#2A7DE1" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round" />

                      <circle cx="12" cy="14" r="3.5" stroke="#2A7DE1" stroke-width="2.5" />

                      <path d="M8 7L9.5 5H14.5L16 7" stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>

                  <p class="bb-upload-title">
                    {{ "upload image" | transloco }}
                  </p>

                  <small class="bb-upload-sub">
                    {{ 'PNG / JPG' | transloco }}
                  </small>
                </div>

                <div *ngIf="imagePreview" class="bb-preview-container">
                  <img [src]="imagePreview" class="bb-preview-img" />

                  <button type="button" class="bb-btn bb-btn-secondary bb-btn-sm" (click)="fileInput.click(); $event.stopPropagation()">
                    {{ "change image" | transloco }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          @if(!isUpdatePage) {
            <div class="bb-field bb-field-full">
              <label class="bb-label">
                {{ 'business type' | transloco }}
              </label>

              <div class="bb-form-grid">
                <label class="bb-card bb-p-16 bb-check-line" *ngFor="let item of warehouseTypes" [for]="item.id">
                  <input
                    class="bb-checkbox"
                    [ngClass]="{
                      'is-invalid': data.get('type')?.touched && data.get('type')?.invalid,
                      'is-valid': data.get('type')?.touched && data.get('type')?.valid
                    }"
                    type="radio"
                    formControlName="type"
                    [value]="item.value"
                    [id]="item.id"
                  />

                  {{ item.label | transloco }}
                </label>
              </div>

              @if(shouldShowError('type')) {
                <div class="bb-field-error">{{ getErrorMessage('type', ('business type' | transloco)) }}</div>
              }
            </div>
          }

          <div class="bb-field bb-field-full">
            <label class="bb-label">
              {{ 'business_settings' | transloco }}
            </label>

            <div class="bb-form-grid">
              <div class="bb-shift-option-row">
                <div>
                  <strong>{{ 'edit_price' | transloco }}</strong>
                  <small>{{ 'edit_price_desc' | transloco }}</small>
                </div>

                <label class="bb-switch">
                  <input type="checkbox" formControlName="edit_price" />
                  <span></span>
                </label>
              </div>

              <div class="bb-shift-option-row">
                <div>
                  <strong>{{ 'quantityguard' | transloco }}</strong>
                  <small>{{ 'quantityguard_desc' | transloco }}</small>
                </div>

                <label class="bb-switch">
                  <input type="checkbox" formControlName="quantityguard" />
                  <span></span>
                </label>
              </div>

              <div class="bb-shift-option-row bb-field-full">
                <div>
                  <strong>{{ 'has_delivery' | transloco }}</strong>
                  <small>{{ 'has_delivery_desc' | transloco }}</small>
                </div>

                <label class="bb-switch">
                  <input type="checkbox" formControlName="has_delivery" />
                  <span></span>
                </label>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="bb-field bb-field-full bb-flex bb-justify-end">
            <button
              type="button"
              class="bb-btn bb-btn-primary bb-btn-wide"
              (click)="onSubmit()"
              [class.is-disabled]="data.invalid || !selectedUsers.length"
            >
              {{ "Submit" | transloco }}
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</section>